import ApiService from "../../services/api";
import { filterBy } from "@progress/kendo-data-query";
import { bus } from "../../main";

import helpers from "../../shared/fleetbox-helpers";

import verticalTable from "./verticalTable.vue";
import horizontalTable from "./horizontalTable.vue";
import mapRealtime from "./map.vue";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
	components: {
		verticalTable,
		horizontalTable,
		mapRealtime
	},
	data: function() {
		return {
			vehicleIdFilterField: "number_plate",
			loading: false,
			created: true,
			items: [],
			pollingTime: 300, //s
			polling: null,
			realtimeDataPendingRequest: null,
			showMap: true,
			showVerticalTable: false,
			showHorizontalTable: false,
			config: {
				mapInitialLocation: {
					lat: 43.1107,
					lng: 12.3908
				}
			},

			canExportGridData: false,

			//#region filters
			showTableMapPopover: false,
			mapTableVisualizationSelected: "",
			vehicles: [],
			vehiclesSelected: [],
			vehiclesMultiSelectedUpdated: 0,
			filtersByQuery: false,

			drivers: [],
			driversSelected: [],

			categories: [],

			itemVehicleTemplate: "<div style='height: 30px'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",
			tagVehicleTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",

			itemDriverTemplate: "<div style='height: 30px'>#= surname # #= name # <br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",
			tagDriverTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= surname # #= name # <br /><div style='font-size: 8px'> #= fiscal_code # </div></div>",

			statusFilter: [
				{
					id: "off",
					value: "fermo"
				},
				{
					id: "stop",
					value: "INATTIVO"
				},
				{
					id: "active",
					value: "MOVIMENTO"
				}
			],
			filtersByHotizontalTableHead: []
			//#endregion
		};
	},

	watch: {
		showVerticalTable(newValue) {
			if (newValue) this.showHorizontalTable = false;
		},
		showHorizontalTable(newValue) {
			if (newValue) this.showVerticalTable = false;
		},
		showTableMapPopover() {
			var self = this;
			self.$root.$emit("bv::hide::tooltip");
			setTimeout(() => {
				self.$root.$emit("bv::hide::tooltip");
			}, 700);
		}
	},

	created() {
		var self = this;
		if (this.settings && this.settings.geoLocation.refreshInterval) {
			this.pollingTime = this.settings.geoLocation.refreshInterval;
		}

		if (this.settings && this.settings.geoLocation.viewType) {
			if (this.settings.geoLocation.viewType == "map, verticalGrid") {
				this.showMap = true;
				this.showVerticalTable = true;
				this.showHorizontalTable = false;
			} else if (this.settings.geoLocation.viewType == "map, horizontalGrid") {
				this.showMap = true;
				this.showVerticalTable = false;
				this.showHorizontalTable = true;
			} else if (this.settings.geoLocation.viewType == "horizontalGrid") {
				this.showMap = false;
				this.showVerticalTable = false;
				this.showHorizontalTable = true;
			} else {
				this.showMap = true;
				this.showVerticalTable = false;
				this.showHorizontalTable = false;
			}
		}

		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;

		var icon = helpers.getIconForVisualizationType(this.showMap, this.showHorizontalTable, this.showVerticalTable);
		this.mapTableVisualizationSelected = `../../${icon}`;

		if (this.settings && this.settings.canExportGridData) {
			this.canExportGridData = true;
		}

		//#region filters
		this.getAllVehicles();
		this.getAllDrivers();
		//#endregion

		this.getCategoriesData();
		bus.$emit("show-spinner-loading");
		//this.pollData();

		if (this.$route.query && this.$route.query.vehicleId) {
			this.filtersByQuery = true;
		}

		bus.$on("set-address-to", self.onSetAddressRequest.bind(self));
	},
	beforeDestroy() {
		bus.$off("set-address-to");
		clearInterval(this.polling);
	},
	methods: {
		//#region FILTERS
		//HT grid filter change
		applyFilter() {
			var valuesFiltered = [];
			this.vehiclesSelected.forEach(f => {
				valuesFiltered.push(f);
			});

			var valuesFilteredDrivers = [];
			this.driversSelected.forEach(f => {
				valuesFilteredDrivers.push(f);
			});

			bus.$emit("on-filter-changed");
			bus.$emit("filter-head-change", [
				{
					field: this.vehicleIdFilterField,
					filterType: "multiselect",
					filterItemsSelected: valuesFiltered
				},
				{
					field: "driver_name",
					filterType: "multiselect",
					filterItemsSelected: valuesFilteredDrivers
				}
			]);
			//this.updateVisibilityItemsByHeadFilter();
			this.getVisibleItems(this.items);
		},
		resetFilter() {
			this.vehiclesSelected = [];
			this.driversSelected = [];

			bus.$emit("on-filter-changed");
			bus.$emit("filter-head-change", [
				{
					field: this.vehicleIdFilterField,
					filterType: "multiselect",
					filterItemsSelected: []
				},
				{
					field: "driver_name",
					filterType: "multiselect",
					filterItemsSelected: []
				}
			]);

			this.getVisibleItems(this.items);
		},
		onHorizontalGridHeaderFilter(filters) {
			var self = this;

			self.filtersByHotizontalTableHead = filters;
			self.setVisibilityItemsByTableHeaderFilters();

			var filtersC = self._.clone(filters);

			bus.$emit("on-ht-grid-filter-changed", filtersC);
		},
		setVisibilityItemsByTableHeaderFilters() {
			var self = this;
			var itemsToReturn = this.items;

			var filters = self.filtersByHotizontalTableHead;

			if (filters && filters.length > 0) {
				filters.forEach(f => {
					if (f.type == "datetime") {
						var minDateFilter = f.filter.filters[0];
						var maxDateFilter = f.filter.filters[1];

						var minDate = null;
						if (minDateFilter.value) {
							minDate = moment(minDateFilter.value);
						}

						var maxDate = null;
						if (maxDateFilter.value) {
							maxDate = moment(maxDateFilter.value);
						}

						if (minDate && maxDate) {
							itemsToReturn = itemsToReturn.filter(item => {
								return item[f.field] && moment(item[f.field]) >= minDate && moment(item[f.field]) <= maxDate;
							});
						}
					} else {
						itemsToReturn = filterBy(itemsToReturn, f.filter);
					}
				});
			}

			self.items.forEach(item => {
				var isNotFiltered = _.some(itemsToReturn, f => {
					return f.id == item.id;
				});

				if (isNotFiltered) {
					item.visible = true;
				} else {
					item.visible = false;
				}
			});
		},
		getIfAnyFiltersIsApplied() {
			var result = false;

			if (this.vehiclesSelected.length > 0 || this.driversSelected.length > 0 || this.filtersByHotizontalTableHead.length > 0) {
				result = true;
			}

			return result;
		},
		getVisibleItems(items) {
			var self = this;

			var itemsToReturn = items;

			if (self.getIfAnyFiltersIsApplied() == false) {
				//do nothing
			} else {
				var self = this;
				let verifyVehicleSelectedFunction = null;

				if (self.vehicleIdFilterField == "code") {
					verifyVehicleSelectedFunction = function(item) {
						return _.some(self.vehiclesSelected, f => {
							return f.toLowerCase() == item.code;
						});
					};
				} else {
					verifyVehicleSelectedFunction = function(item) {
						return _.some(self.vehiclesSelected, f => {
							return f.toLowerCase() == item.number_plate;
						});
					};
				}

				itemsToReturn.forEach(item => {
					var isFilteredByPlate = false;
					isFilteredByPlate = verifyVehicleSelectedFunction(item);

					var isFilteredByDriver = _.some(self.driversSelected, f => {
						return f.toLowerCase() == item.driver_name;
					});

					if ((self.vehiclesSelected.length == 0 || isFilteredByPlate) && (self.driversSelected.length == 0 || isFilteredByDriver)) item.visible = true;
					else item.visible = false;
				});

				var filters = self.filtersByHotizontalTableHead;

				if (filters && filters.length > 0) {
					filters.forEach(f => {
						if (f.type == "datetime") {
							var minDateFilter = f.filter.filters[0];
							var maxDateFilter = f.filter.filters[1];

							var minDate = null;
							if (minDateFilter.value) {
								minDate = moment(minDateFilter.value);
							}

							var maxDate = null;
							if (maxDateFilter.value) {
								maxDate = moment(maxDateFilter.value);
							}

							if (minDate && maxDate) {
								itemsToReturn = itemsToReturn.filter(item => {
									return item[f.field] && moment(item[f.field]) >= minDate && moment(item[f.field]) <= maxDate;
								});
							}
						} else {
							itemsToReturn = filterBy(itemsToReturn, f.filter);
						}
					});
				}
			}
			items.forEach(item => {
				var isNotFiltered = _.some(itemsToReturn, f => {
					return f.id == item.id;
				});

				if (isNotFiltered) {
					item.visible = true;
				} else {
					item.visible = false;
				}
			});
		},
		onFilterRemoved(field) {
			if (field == "number_plate" || field == "code") {
				this.vehiclesSelected = [];
			} else if (field == "driver_name") {
				this.driversSelected = [];
			}
		},
		filterPlateChange(e) {
			this.vehiclesSelected = e.sender.value();
			// var valuesFiltered = [];
			// this.vehiclesSelected.forEach(f => {
			// 	valuesFiltered.push(f);
			// });
			//this.updateVisibilityItemsByHeadFilter();
			// bus.$emit("on-filter-changed");
			// bus.$emit("filter-head-change", {
			// 	field: this.vehicleIdFilterField,
			// 	filterType: "multiselect",
			// 	filterItemsSelected: valuesFiltered
			// });
		},
		filterDriverChange(e) {
			this.driversSelected = e.sender.value();
			// var valuesFiltered = [];
			// this.driversSelected.forEach(f => {
			// 	valuesFiltered.push(f);
			// });
			//this.updateVisibilityItemsByHeadFilter();
			// bus.$emit("on-filter-changed");
			// bus.$emit("filter-head-change", {
			// 	field: "driver_name",
			// 	filterType: "multiselect",
			// 	filterItemsSelected: valuesFiltered
			// });
		},
		updateVisibilityItemsByHeadFilter() {
			var self = this;
			let verifyVehicleSelectedFunction = null;

			if (self.vehicleIdFilterField == "code") {
				verifyVehicleSelectedFunction = function(item) {
					return _.some(self.vehiclesSelected, f => {
						return f.toLowerCase() == item.code;
					});
				};
			} else {
				verifyVehicleSelectedFunction = function(item) {
					return _.some(self.vehiclesSelected, f => {
						return f.toLowerCase() == item.number_plate;
					});
				};
			}

			this.items.forEach(item => {
				var isFilteredByPlate = false;
				isFilteredByPlate = verifyVehicleSelectedFunction(item);

				var isFilteredByDriver = _.some(self.driversSelected, f => {
					return f.toLowerCase() == item.driver_name;
				});

				if ((self.vehiclesSelected.length == 0 || isFilteredByPlate) && (self.driversSelected.length == 0 || isFilteredByDriver)) item.visible = true;
				else item.visible = false;
			});
		},
		//#endregion FILTERS
		//#region DATA
		showMaptable(v) {
			if (v == "ht") {
				this.showHorizontalTable = !this.showHorizontalTable;
				if (this.showHorizontalTable) this.showVerticalTable = false;
			} else if (v == "m") {
				this.showMap = !this.showMap;
			} else if (v == "vt") {
				this.showVerticalTable = !this.showVerticalTable;
				if (this.showVerticalTable) this.showHorizontalTable = false;
			}

			if (!this.showHorizontalTable && !this.showMap && !this.showVerticalTable) this.showMap = this.showHorizontalTable = true;

			var icon = helpers.getIconForVisualizationType(this.showMap, this.showHorizontalTable, this.showVerticalTable);
			this.mapTableVisualizationSelected = `../../${icon}`;

			this.onCloseShowTableMapPopover();
		},
		onCloseShowTableMapPopover() {
			this.showTableMapPopover = false;
		},
		onAddressUpdate(e) {
			var item = this.items.find(item => {
				return item.id == e.id;
			});

			if (item) {
				item.address = e.address;
			}
		},
		getCategoriesData() {
			var self = this;
			ApiService.getCategoriesData().then(res => {
				self.categories = res.map(function(item) {
					return {
						id: item.id,
						box_drive_icon: item.box_drive_icon,
						box_stop_icon: item.box_stop_icon,
						box_still_icon: item.box_still_icon
					};
				});
				self.getData();
			});
		},
		getAllVehicles: function() {
			var self = this;
			ApiService.getVehiclesLookup({ page: 0, pageSize: 1000000 }, this.vehicleIdFilterField).then(res => {
				self.vehicles = res.items
					.filter(vh => {
						return vh.box_active;
					})
					.map(function(vehicle) {
						return {
							id: vehicle.number_plate,
							name: vehicle.name,
							number_plate: vehicle.number_plate,
							name_numberplate: `${vehicle.number_plate} ${vehicle.name}`
						};
					});

				self.vehicles = self._.sortBy(self.vehicles, function(item) {
					return item.number_plate.toLowerCase();
				});

				self.pollData();
			});
		},
		getAllDrivers() {
			var self = this;
			ApiService.getDriversData({ page: 0, pageSize: 100000, onlyActiveWithBox: true }).then(res => {
				self.drivers = res.items.map(function(driver) {
					return {
						id: `${driver.surname ? driver.surname.toLowerCase() : ""} ${driver.name ? driver.name.toLowerCase() : ""}`,
						name: driver.name ? driver.name.toLowerCase() : "",
						surname: driver.surname ? driver.surname.toLowerCase() : "",
						name_surname_fiscalcode: `${driver.name} ${driver.surname} ${driver.fiscal_code}`,
						fiscal_code: driver.fiscal_code
					};
				});

				self.drivers = self._.sortBy(self.drivers, ["surname", "name"]);
			});
		},
		pollData() {
			this.polling = setInterval(() => {
				this.getData();
			}, this.pollingTime * 1000);
		},
		getData: function() {
			var self = this;
			this.loading = true;

			if (this.realtimeDataPendingRequest === null) {
				this.realtimeDataPendingRequest = ApiService.getRealtimeGeolocation(this.query)
					.then(res => {
						// var resTmp = res
						// 	.filter(function(x) {
						// 		return x.status == "stop" || x.status == "active" || x.last_privacy_mode == true;
						// 	})
						// 	.slice(0, 5);

						// var resTmpInactive = res
						// 	.filter(function(x) {
						// 		return x.status != "stop" && x.status != "active";
						// 	})
						// 	.slice(0, 5);

						// var union = [...new Set([...resTmp, ...resTmpInactive])];
						//var oldItems = self._.clone(self.items);
						//self.getVisibleItems(oldItems);

						self.items = res
							.filter(function(item) {
								return item.box_active;
							})
							.map(function(item) {
								return {
									create_date: item.create_date,
									current_position: item.current_position,
									status: item.status,
									statusFriendly: self.getUserFriendlyStatus(item.status, item.last_privacy_mode),
									driver_id: item.driver_id,
									driver_name: item.driver_name ? item.driver_name.toLowerCase() : "",
									mobile_phone_number: item.mobile_phone_number,
									icon: self.getIconFromCategories(item.category_id, item.status, item.last_privacy_mode, item.box_active),
									id: item.id,
									last_event_date: item.last_event_date,
									number_plate: item.number_plate,
									code: item.vehicle_code ? item.vehicle_code : "",
									update_date: item.update_date,
									vehicle_id: item.vehicle_id,
									vehicle_name: item.vehicle_name,
									selected: self.isItemSelected(item.id),
									visible: false,
									formattedCoordinates: self.formattedCoordinates(item.current_position),
									address: self.setAddress(item.id),
									last_odometer_km_value: item.last_odometer_km_value || item.last_odometer_km_value == 0 ? kendo.toString(item.last_odometer_km_value, "n2") : "",
									last_odometer_lt_value: item.last_odometer_lt_value || item.last_odometer_lt_value == 0 ? kendo.toString(item.last_odometer_lt_value, "n2") : "",
									status_date: item.status_date,
									last_speed: item.last_speed || item.last_speed == 0 ? kendo.toString(item.last_speed, "n2") : "",
									last_privacy_mode: item.last_privacy_mode,
									type: item.type
								};
							});

						if (!(self.filtersByQuery && self.$route.query && self.$route.query.vehicleId)) {
							self.getVisibleItems(self.items);
						}

						var allDriversInTable = _.uniqBy(
							self.items.map(function(x) {
								return {
									driver_name: x.driver_name
								};
							}),
							"driver_name"
						);

						self.drivers = self.drivers.filter(function(driver) {
							var surname_name = `${driver.surname ? driver.surname.toLowerCase() : ""} ${driver.name ? driver.name.toLowerCase() : ""}`;
							return _.some(allDriversInTable, { driver_name: surname_name });
						});

						self.drivers = self._.sortBy(self.drivers, item => {
							return item.name.toLowerCase();
						});

						self.drivers.unshift({
							id: "ND",
							name: "NON DISPONIBILE",
							surname: "",
							fiscal_code: ""
						});

						// var allVehiclesInTable = _.uniqBy(
						// 	self.items.map(function(x) {
						// 		return {
						// 			number_plate: x.number_plate ? x.number_plate.toLowerCase() : ""
						// 		};
						// 	}),
						// 	"number_plate"
						// );

						// self.vehicles = self.vehicles.filter(function(vehicle) {
						// 	var number_plate = vehicle.number_plate ? vehicle.number_plate.toLowerCase() : "";
						// 	return _.some(allVehiclesInTable, { number_plate: number_plate });
						// });

						if (self.filtersByQuery && self.$route.query && self.$route.query.vehicleId) {
							var existsVehicleIsInFilter = self.vehicles.some(function(vh) {
								return vh.number_plate == self.$route.query.vehicleId;
							});

							if (existsVehicleIsInFilter) {
								self.$nextTick(function() {
									setTimeout(() => {
										self.vehiclesSelected.push(self.$route.query.vehicleId);
										var valuesFiltered = [];
										self.vehiclesSelected.forEach(f => {
											valuesFiltered.push(f);
										});
										self.getVisibleItems(self.items);
										bus.$emit("on-filter-changed");
										bus.$emit("filter-head-change", [
											{
												field: self.vehicleIdFilterField,
												filterType: "multiselect",
												filterItemsSelected: valuesFiltered
											}
										]);
									}, 200);
								});
							}
							self.filtersByQuery = false;
						}

						if (self.created) {
							//self.setAddressByBulkReverse();
							//self.setAddressByBulkReverseParallel(self.items);

							self.created = false;
						}

						bus.$emit("updated-data");
					})
					.finally(res => {
						self.realtimeDataPendingRequest = null;
						bus.$emit("hide-spinner-loading");
					});
			}
		},
		onSetAddressRequest(data) {
			if (data.source == "horizontalTable" && this.showHorizontalTable) {
				this.setAddressByBulkReverseParallel(data.items);
			} else if (data.source == "verticalTable" && this.showVerticalTable) {
				this.setAddressByBulkReverseParallel(data.items);
			}
			else if (!this.showHorizontalTable && !this.showVerticalTable) {
				this.setAddressByBulkReverseParallel(data.items);
			}
		},
		setAddressByBulkReverseParallel(items) {
			var self = this;
			var index = 0;
			var data = [];

			var result = [];
			var reverseGeocodingCalls = [];

			var bulkGetAddress = function(data) {
				if (data.length > 0) {
					return ApiService.getBulkReverseGeocoding(data).then(resBulk => {
						if (resBulk && resBulk.length > 0) {
							for (var i = 0; i < resBulk.length; i++) {
								var resVehicle = resBulk[i];
								var resToReturn = {
									numberPlate: resVehicle.id,
									address: ""
								};

								var res = resVehicle.data;
								if (res && res.length > 0) {
									var newAddress = self._.find(res, function(na) {
										return (
											self._.find(na.types, function(x) {
												return x === "streetAddress";
											}) != null
										);
									});

									if (!newAddress) {
										newAddress = res[0];
									}

									if (newAddress && newAddress.formattedAddress) {
										resToReturn.address = newAddress.formattedAddress;
									}
								}

								result.push(resToReturn);
							}
						}
					});
				}
			};

			for (var i = 0; i < items.length; i++) {
				var item = items[i];

				if (!item.address && item.current_position) {
					var par = {
						id: item.number_plate,
						latitude: item.current_position.lat,
						longitude: item.current_position.lon
					};

					data.push(par);
					index++;
				}

				if (index % 25 == 0) {
					reverseGeocodingCalls.push(bulkGetAddress(data));
					data = [];
				}
			}
			if (data.length > 0) {
				reverseGeocodingCalls.push(bulkGetAddress(data));
			}

			Promise.all(reverseGeocodingCalls)
				.then(responses => {
					self.updateAddress(result);
				})
				.catch(err => {
					console.log(err);
				});
		},
		updateAddress(result) {
			//let dstart = new Date();
			for (var i = 0; i < result.length; i++) {
				var res = result[i];
				var itemToUpdate = this.items.find(item => {
					return item.number_plate == res.numberPlate;
				});

				if (itemToUpdate) {
					itemToUpdate.address = res.address;
				}
			}
			// let dstop = new Date();
			// const diffTime = Math.abs(dstop - dstart);
			// console.log(diffTime + " milliseconds");
		},
		setAddressByBulkReverse() {
			var self = this;

			var data = [];

			var bulkGetAddress = function(data) {
				if (data.length > 0) {
					ApiService.getBulkReverseGeocoding(data).then(resBulk => {
						if (resBulk && resBulk.length > 0) {
							for (var i = 0; i < resBulk.length; i++) {
								var resVehicle = resBulk[i];
								var itemToUpdate = self.items.find(item => {
									return item.number_plate == resVehicle.id;
								});
								if (itemToUpdate) {
									var res = resVehicle.data;
									if (res && res.length > 0) {
										var newAddress = self._.find(res, function(item) {
											return (
												self._.find(item.types, function(x) {
													return x === "streetAddress";
												}) != null
											);
										});

										if (!newAddress) {
											newAddress = res[0];
										}

										var address = "";
										if (newAddress && newAddress.formattedAddress) {
											address = newAddress.formattedAddress;
										}
										itemToUpdate.address = address;
									}
								}
							}
						}
					});
				}
			};

			var index = 0;
			for (var i = 0; i < self.items.length; i++) {
				var item = self.items[i];

				if (!item.address && item.current_position) {
					var par = {
						id: item.number_plate,
						latitude: item.current_position.lat,
						longitude: item.current_position.lon
					};

					data.push(par);
					index++;
				}

				if (index % 25 == 0) {
					bulkGetAddress(data);
					data = [];
				}
			}
			if (data.length > 0) {
				bulkGetAddress(data);
			}
		},
		getUserFriendlyStatus(status, lastPrivacyMode) {
			if (lastPrivacyMode) {
				return "privato";
			}

			switch (status) {
				case "off":
					return "fermo";
					break;
				case "stop":
					return "inattivo";
					break;
				case "active":
					return "movimento";
					break;
				default:
					return "sconociuto";
					break;
			}
		},
		getIconFromCategories(categoryId, status, lastPrivacyMode, box_active) {
			if (lastPrivacyMode) {
				return "/assets/map/icon/privacy_mod.png";
			}

			if (!box_active) {
				return "/assets/map/icon/blank.png";
			}

			var cat = this.categories.find(function(c) {
				return c.id == categoryId;
			});

			var icon = "";

			if (cat) {
				switch (status) {
					case "off":
						if (cat.box_stop_icon) icon = cat.box_stop_icon;
						break;
					case "stop":
						if (cat.box_still_icon) icon = cat.box_still_icon;
						break;
					case "active":
						if (cat.box_drive_icon) icon = cat.box_drive_icon;
						break;
					default:
						break;
				}
			}

			return icon || "/assets/map/icon/blank.png";
		},
		setAddress(idItem) {
			if (this.items) {
				var item = this._.find(this.items, function(x) {
					return x.id == idItem;
				});
				if (item && item.address) {
					return item.address;
				}
			}

			return "";
		},
		isItemSelected(idItem) {
			if (this.items) {
				var item = this._.find(this.items, function(x) {
					return x.id == idItem;
				});
				if (item && item.selected) {
					return true;
				}
			}

			return false;
		},

		isItemVisible(oldItems, vehicle) {
			if (oldItems && oldItems.length > 0) {
				var item = this._.find(oldItems, function(x) {
					return x.number_plate == vehicle.number_plate;
				});
				if (item) {
					var itemsToCheck = [item];
					this.getVisibleItems(itemsToCheck);
					return itemsToCheck[0].visible;
				} else {
					var itemsToCheck = [item];
					this.getVisibleItems(itemsToCheck);
					return itemsToCheck[0].visible;
				}
			} else if (this.$route.query && this.$route.query.vehicleId) {
				if (vehicle.number_plate == this.$route.query.vehicleId) return true;
				return false;
			}

			return true;
		},

		onMarkerClick: function(e) {
			bus.$emit("marker-click", e);
		},

		onSelectedRow: function(e) {
			bus.$emit("on-selected-row", e);
		},
		formattedCoordinates(current_position) {
			if (current_position && current_position.lat && current_position.lon)
				return helpers.formatCoordinate(current_position.lat, "lat") + ", " + helpers.formatCoordinate(current_position.lon, "lon");

			return null;
		}

		//#endregion
	},
	computed: {
		...mapGetters(["settings"]),
		mapClass: function() {
			if (this.showHorizontalTable) {
				return "mapwithHorizontalTable";
			}

			return " mapNoTables";
		},
		containerMapClass: function() {
			if (this.showVerticalTable) {
				return "col-lg-8 ";
			}
			return "col-lg-12";
		},
		horizontalTableClass: function() {
			if (!this.showMap) {
				return " horizontal-table-without-map";
			}

			return "";
		},
		getStateMIcon() {
			return `../../${helpers.getStateMIcon(this.showMap)}`;
		},
		getStateHTIcon() {
			return `../../${helpers.getStateHTIcon(this.showHorizontalTable)}`;
		},
		getStateVTIcon() {
			return `../../${helpers.getStateVTIcon(this.showVerticalTable)}`;
		},
		itemsVisible() {
			return this.items.filter(function(item) {
				return item.visible == true;
			});
		}
	}
};
